module.exports = __webpack_public_path__ + "img/a3-s75.fc2f9ac1.jpg";